import { render, staticRenderFns } from "./licenseAuthorize.vue?vue&type=template&id=54821840&scoped=true&"
import script from "./licenseAuthorize.vue?vue&type=script&lang=js&"
export * from "./licenseAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./licenseAuthorize.vue?vue&type=style&index=0&id=54821840&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54821840",
  null
  
)

export default component.exports